import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

// Opciones para el campo de importancia
const importanceOptions = ["low", "medium", "high"];

function AppIbEventsDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const rawData = location.state?.data || {};

	const { handleDelete, handleSubmit } = useHandleActionItem();

	const initialState = {
		id: "",
		title: "",
		description: "",
		event_date: "",
		importance: "",
		event_type: "",
	};

	const [event, setEvent] = useState(initialState);

	const fieldMap = {
		Título: "title",
		title: "title",
		Descripción: "description",
		description: "description",
		"Fecha Evento": "event_date", // 👈 corregido
		event_date: "event_date",
		Importancia: "importance",
		importance: "importance",
		"Tipo Evento": "event_type", // 👈 corregido
		event_type: "event_type",
		ID: "id",
		id: "id",
	};

	useEffect(() => {
		console.log("Raw data from API:", rawData);

		if (locationType === "edit" && Object.keys(rawData).length > 0) {
			// Crear un objeto para mapear los datos
			const mappedData = { ...initialState };

			// Mapear ID
			mappedData.id = rawData.ID || rawData.id || "";

			Object.keys(rawData).forEach((key) => {
				const mappedKey = fieldMap[key];
				if (mappedKey) {
					mappedData[mappedKey] = rawData[key];
				}
			});

			console.log("Mapped data:", mappedData);
			setEvent(mappedData);
		}
	}, [locationType, rawData]);

	const validateForm = () => {
		const requiredFields = ["title", "description", "event_date", "importance", "event_type"];
		for (const field of requiredFields) {
			if (!event[field]) {
				Toast.fire({
					icon: "error",
					title: `El campo ${field} es requerido`,
					background: "#1e2836",
				});
				return false;
			}
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setEvent((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (e) => {
		e.preventDefault();
		if (!validateForm()) return;

		try {
			const eventData = { ...event };

			// Si es un nuevo evento y no tiene ID, no lo enviamos
			if (locationType === "add" && !eventData.id) {
				delete eventData.id;
			}

			await handleSubmit(locationType === "add" ? "add" : "update", "events", eventData);
			navigate("/appIbEvents");
		} catch (error) {
			console.error("Error al guardar el evento:", error);
			Toast.fire({
				icon: "error",
				title: "Error al guardar el evento",
				background: "#1e2836",
			});
		}
	};

	const handleDeleteForm = async (e) => {
		e.preventDefault();
		try {
			await handleDelete({ id: event.id }, "events", true);
			navigate("/appIbEvents");
		} catch (error) {
			console.error("Error al eliminar el evento:", error);
			Toast.fire({
				icon: "error",
				title: "Error al eliminar el evento",
				background: "#1e2836",
			});
		}
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Evento" : "Actualizar Evento"}</h1>

				{/* Campo Título */}
				<div className="mb-3">
					<label className="form-label">
						Título <span className="text-danger">*</span>
					</label>
					<input
						type="text"
						className="form-control bg-white bg-opacity-5"
						value={event.title || ""}
						onChange={(e) => handleInputChange("title", e.target.value)}
					/>
				</div>

				{/* Campo Descripción */}
				<div className="mb-3">
					<label className="form-label">
						Descripción <span className="text-danger">*</span>
					</label>
					<textarea
						className="form-control bg-white bg-opacity-5"
						value={event.description || ""}
						onChange={(e) => handleInputChange("description", e.target.value)}
						rows="4"></textarea>
				</div>

				{/* Campo Fecha del Evento */}
				<div className="mb-3">
					<label className="form-label">
						Fecha del Evento <span className="text-danger">*</span>
					</label>
					<input
						type="datetime-local"
						className="form-control bg-white bg-opacity-5"
						value={event.event_date || ""}
						onChange={(e) => handleInputChange("event_date", e.target.value)}
					/>
				</div>

				{/* Campo Importancia */}
				<div className="mb-3">
					<label className="form-label">
						Importancia <span className="text-danger">*</span>
					</label>
					<select
						className="form-select bg-white bg-opacity-5"
						value={event.importance || ""}
						onChange={(e) => handleInputChange("importance", e.target.value)}>
						<option value="">Seleccionar importancia</option>
						{importanceOptions.map((option) => (
							<option key={option} value={option}>
								{option}
							</option>
						))}
					</select>
				</div>

				{/* Campo Tipo de Evento */}
				<div className="mb-3">
					<label className="form-label">
						Tipo de Evento <span className="text-danger">*</span>
					</label>
					<input
						type="text"
						className="form-control bg-white bg-opacity-5"
						value={event.event_type || ""}
						onChange={(e) => handleInputChange("event_type", e.target.value)}
					/>
				</div>

				{/* Botones de acción */}
				<div className="mb-3 d-flex justify-content-around">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button type="button" onClick={() => navigate("/appIbEvents")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button type="button" onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default AppIbEventsDetails;
